import Vue from 'vue'
// import Vue from 'vue/dist/vue.js';

import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullPage from 'vue-fullpage.js'
import VueSlideoutPanel from 'vue2-slideout-panel'
import './main.css'
//import 'fullpage.js/dist/fullpage.css'
import App from './App.vue'
import AppSlidePanel from './components/SlidePanel.vue'

Vue.use(VueFullPage)
Vue.use(VueSlideoutPanel)

Vue.config.productionTip = false

Vue.component('slide-panel', AppSlidePanel);

new Vue({
  render: h => h(App)
}).$mount('#app')
